/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import {displayError} from '../../app/errorDisplayer';
import DataSourceDecorationEdit from './DataSourceDecorationEdit.react';
import LoadingButton from '../../fw/LoadingButton.react';
import {injectIntl, defineMessages} from 'react-intl';
import { Form, Textarea } from 'formsy-react-components';
import {safeJSONparse} from "../../../common/util/safeJSONparse";

export const messages = defineMessages({
    textarea: {id: 'DataSourceManualQueryEdit.textarea', 'defaultMessage': 'DatiQuery'},
    save: {id: 'DataSourceManualQueryEdit.save', 'defaultMessage': 'Save DatiQuery'},
});

class DataSourceManualQueryEdit extends React.Component {

    static propTypes = {
        apply: PropTypes.func,
        dataSource: PropTypes.object,
        goBack: PropTypes.func,
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
    };

    constructor(props) {
        super(props);

        this.state = {
            canSubmit: false,
        };
    }

    add = (data) => {
        let args = safeJSONparse(this.props.dataSource.args);
        args['query'] = data.datiquery;

        let newDataSource = {
            id: this.props.dataSource.id,
            args: args
        };

        return this.props.apply(newDataSource);
    };

    enableButton = () => {
        this.setState({
            canSubmit: true
        });
    };

    disableButton = () => {
        this.setState({
            canSubmit: false
        });
    };

    render() {
        let dataSource = this.props.dataSource;

        let args = safeJSONparse(dataSource.args);

        let content = (
            <div style={{width: '100%', paddingBottom: '15em'}}>
                <Form
                    onInvalid={this.disableButton}
                    onValid={this.enableButton}
                    onValidSubmit={this.add}
                >
                    <Textarea
                        label={this.props.intl.formatMessage(messages.textarea)}
                        name="datiquery"
                        required
                        value={args.query}
                    />

                    <LoadingButton className="btn btn-primary"
                                   disabled={!this.state.canSubmit}
                                   type="submit">{this.props.intl.formatMessage(messages.save)}</LoadingButton>
                </Form>
            </div>
        );

        try {
            return (
                <DataSourceDecorationEdit
                    dataSource={dataSource}
                    goBack={this.props.goBack}
                >

                    <div style={{padding: '2em'}}>
                        {content}
                    </div>
                </DataSourceDecorationEdit>
            );
        } catch (e) {
            displayError(e);
            return (<div>Error</div>);
        }
    }
}


export default Relay.createContainer(injectIntl(DataSourceManualQueryEdit), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        dataSource: () => {
            return Relay.QL`
                fragment on DataSource {
                    id,
                    realId,
                    channelDefs {
                        id,
                        name,
                        icon,
                    },
                    args,
                    ${DataSourceDecorationEdit.getFragment('dataSource')}
                }`;
        }
    }
});
